/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Shares_LabelInputs */

const en_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shares`)
};

const fr_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partages`)
};

const de_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktien`)
};

const it_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

const ru_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акции`)
};

const es_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

const zh_cn2_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`股票`)
};

const ja_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式`)
};

const hi_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयरों`)
};

const pt_pt2_team_share_shares_label = /** @type {(inputs: Team_Share_Shares_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Shares" |
*
* @param {Team_Share_Shares_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_shares_label = /** @type {((inputs?: Team_Share_Shares_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Shares_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_shares_label(inputs)
	if (locale === "de") return de_team_share_shares_label(inputs)
	if (locale === "it") return it_team_share_shares_label(inputs)
	if (locale === "ru") return ru_team_share_shares_label(inputs)
	if (locale === "es") return es_team_share_shares_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_shares_label(inputs)
	if (locale === "ja") return ja_team_share_shares_label(inputs)
	if (locale === "hi") return hi_team_share_shares_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_shares_label(inputs)
	return en_team_share_shares_label(inputs)
});